export const GET_DATA_UPDATED_ON_QUERY = `
  query GetDataUpdatedOn($studentId: String) {
    getDataUpdatedOn(studentId: $studentId) {
      topicMastery
      learningSessions
    }
  }
`;
